import React, { Component } from 'react'
import { connect } from 'react-redux'
import clone from 'clone'
import { Link } from 'react-router-dom'
import { Layout, Divider } from 'antd'
import options from './options'
import Scrollbars from '../../../components/utility/customScrollBar.js'
import {Menu} from 'antd'
// '../../../components/uielements/menu'
import IntlMessages from '../../../components/utility/intlMessages'
import SidebarWrapper from './sidebar.style'
import appActions from '../../../redux/app/actions'
import Logo from '../../../components/utility/logo'
import sidebarBgr from '../../../resource/image/sidebarbgr.jpg'
// auth
import GetOptions from './authorization'

const SubMenu = Menu.SubMenu
// const MenuItemGroup = Menu.ItemGroup
const { Sider } = Layout

const {
    toggleOpenDrawer,
    changeOpenKeys,
    changeCurrent,
    toggleCollapsed,
} = appActions
const stripTrailingSlash = str => {
    if (str.substr(-1) === '/') {
        return str.substr(0, str.length - 1)
    }
    return str
}

class Sidebar extends Component {
    constructor(props) {
        super(props)
        this.handleClick = this.handleClick.bind(this)
        this.onOpenChange = this.onOpenChange.bind(this)
    }
    handleClick(e) {
        this.props.changeCurrent([e.key])
        if (this.props.app.view === 'MobileView') {
            setTimeout(() => {
                this.props.toggleCollapsed()
                this.props.toggleOpenDrawer()
            }, 100)
        }
    }
    onOpenChange(newOpenKeys) {
        const { app, changeOpenKeys } = this.props
        const latestOpenKey = newOpenKeys.find(
            key => !(app.openKeys.indexOf(key) > -1)
        )
        const latestCloseKey = app.openKeys.find(
            key => !(newOpenKeys.indexOf(key) > -1)
        )
        let nextOpenKeys = []
        if (latestOpenKey) {
            nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(
                latestOpenKey
            )
        }
        if (latestCloseKey) {
            nextOpenKeys = this.getAncestorKeys(latestCloseKey)
        }
        changeOpenKeys(nextOpenKeys)
    }
    getAncestorKeys = key => {
        const map = {
            sub3: ['sub2'],
        }
        return map[key] || []
    }
    getMenuItem = ({ singleOption, submenuStyle, submenuColor }) => {
        const { key, label, leftIcon, children } = singleOption
        const url = stripTrailingSlash(this.props.url)
        if (children) {
            return (
                <SubMenu
                    key={key}
                    title={
                        <span className="isoMenuHolder" style={submenuColor}>
                            {leftIcon}
                            <span className="nav-text">
                                <IntlMessages id={label} />
                            </span>
                        </span>
                    }
                >
                    {children.map(child => {
                        const linkTo = child.withoutDashboard
                            ? `/${child.key}`
                            : `${url}/${child.key}`
                        return (
                            <Menu.Item style={submenuStyle} key={child.key}>
                                <Link style={submenuColor} to={linkTo}>
                                    {child.leftIcon}
                                    <IntlMessages id={child.label} />
                                </Link>
                            </Menu.Item>
                        )
                    })}
                </SubMenu>
            )
        }
        return (
            <Menu.Item key={key}>
                <Link to={`${url}/${key}`}>
                    <span className="isoMenuHolder" style={submenuColor}>
                        {leftIcon}
                        <span className="nav-text">
                            <IntlMessages id={label} />
                        </span>
                    </span>
                </Link>
            </Menu.Item>
        )
    }
    render() {
        const { app, toggleOpenDrawer, height, user } = this.props
        const collapsed = clone(app.collapsed) && !clone(app.openDrawer)
        const { openDrawer } = app
        const mode = collapsed === true ? 'vertical' : 'inline'

        const styling = {
            background: `linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url(${sidebarBgr})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundColor: '#101E24',
        }
        const submenuStyle = {
            backgroundColor: 'rgba(0,0,0,0.03)',
            color: 'black',
            marginBottom: 15,
            fontSize: 16
        }
        const submenuColor = {
            color: 'white',
        }

        // auth
        let optionAuth = GetOptions(options, user)
        console.log('app.current', app.current)
        return (
            <SidebarWrapper>
                <Sider
                    trigger={null}
                    collapsible={true}
                    collapsed={collapsed}
                    width={275}
                    className="isomorphicSidebar"
                    // onMouseEnter={onMouseEnter}
                    // onMouseLeave={onMouseLeave}
                    style={styling}
                >
                    <Logo collapsed={collapsed} />
                    <Scrollbars style={{ height: height - 110 }}>
                        <Menu
                            onClick={this.handleClick}
                            theme="dark"
                            className="isoDashboardMenu"
                            mode={mode}
                            openKeys={collapsed ? [] : app.openKeys}
                            selectedKeys={app.current}
                            onOpenChange={this.onOpenChange}
                        >
                            {optionAuth.map(singleOption =>
                                this.getMenuItem({
                                    submenuStyle,
                                    submenuColor,
                                    singleOption,
                                })
                            )}
                        </Menu>
                    </Scrollbars>
                </Sider>
            </SidebarWrapper>
        )
    }
}

export default connect(
    state => ({
        app: state.app,
        height: state.app.height,
        user: state.auth.userInfo,
    }),
    { toggleOpenDrawer, changeOpenKeys, changeCurrent, toggleCollapsed }
)(Sidebar)
